<template>
  <div>
    <!-- <v-progress-circular v-if="loading" indeterminate /> -->
    <v-select
      :items="paymentOptions"
      :readonly="readonly"
      :loading="loading"
      label="Payment"
      :value="value"
      item-value="certid"
      @change="$emit('change', $event.paymentid)"
      :error-messages="errors"
      single-line
      return-object
      :clearable="true"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "PaymentSelect",
  data() {
    return {
      myPayments: [],
      loading: true,
      feeTypes: {},
      errors: []
    };
  },
  created() {
    this.loadPayments();
  },
  methods: {
    getFeeType(feeid) {
      let feetype = this.lookup("FeeTypes", feeid);
      return feetype || "";
    },
    async loadPayments() {
      if (!this.personid) this.personid = null;
      this.loading = true;

      try {
        let response = await this.$http.get("/financialbatchitems/", {
          params: { filter: { where: { personid: this.personid } } }
        });
        this.myPayments = [...response.data];
      } catch (e) {
        console.error(e);
        this.handleError(e);
      }

      this.loading = false;
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  computed: {
    ...mapGetters({ lookup: "lookup" }),
    paymentOptions() {
      if (!this.myPayments) {
        return [];
      }

      return this.myPayments
        .sort((p1, p2) => p2.batchitemid - p1.batchitemid)
        .map(payment => {
          let feetypetext = "";
          try {
            var feetype = this.getFeeType(payment.feetypeid);
            if (feetype) feetypetext = feetype;
          } catch (e) {
            console.error(e);
          }
          let paymentid = payment.batchitemid;
          let certid = payment.linkeditemid;
          let text = `${feetypetext} - ${payment.paymentreceiveddate.substr(
            0,
            10
          )} ($${payment.paymentamount})  ${
            payment.linkeditemid == this.value ? "*" : ""
          }`;
          return { paymentid, text, certid };
        });
    }
  },
  props: {
    value: Number,
    personid: {
      required: false,
      default: null,
      type: [Number, String]
    },
    readonly: Boolean
  }
};
</script>
